// src/components/CustomButton.js
import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { VM_Colors } from "../../Styles/VMStyles";

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "999px", // pill shape
  textTransform: "none", // keep text as written (not uppercase)
  border: "1px solid #000",
  backgroundColor: VM_Colors.white,
  color: "#000",
  padding: "6px 20px",
  "&:hover": {
    backgroundColor: VM_Colors.white, 
  },
}));

const CustomButton = ({ children, onClick, ...props }) => {
  return (
    <StyledButton variant="outlined" onClick={onClick} {...props}>
      {children}
    </StyledButton>
  );
};

export default CustomButton;
